<div class="container" *ngIf="possibleWinForNumberOfHits && possibleWinForNumberOfHits.length> 0">
  <div class="row">
    <span i18n="Number of hits@@NumberOfHits">Br. Pogodaka</span>
    <span i18n="Min hits short@@Min">Min</span>
    <span i18n="Max hits short@@Max">Max</span>
  </div>

  <div class="row" *ngFor="let possWinnings of possibleWinForNumberOfHits;">
    <span>{{possWinnings.numberOfHits}} </span>
    <span>{{possWinnings.minWinnings| number:'1.2-2'}}  {{currency}}</span>
    <span>{{possWinnings.maxWinnings| number:'1.2-2'}} {{currency}}</span>
  </div>
</div>
